(function () {
  if (window.__edevInsigniaAddonInit) return;
  window.__edevInsigniaAddonInit = true;

  var CONFIG = {
    insigniaVariantId: 54318528528725,
    productHandle: 'custom-insignia-pair',
    minPairs: 6,
    footwearTypes: ['Lemieux Elite', 'Lemieux Suede', 'Lemieux Offshore', 'Finch Chukka', 'Deck Master'],
    finishes: ['Black', 'Silver', 'Blue'],
    artworkEmail: 'customerservice@equipementdevie.com'
  };

  var CURRENCY_SYMBOLS = { GBP: '£', EUR: '€', USD: '$' };

  var syncing = false;
  var pricePerPairCents = null;

  function loadPrice() {
    fetch('/products/' + CONFIG.productHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (p && p.variants && p.variants[0]) {
          pricePerPairCents = p.variants[0].price;
          refreshAll();
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents, currencyCode) {
    var amount = (cents / 100).toFixed(2);
    var symbol = CURRENCY_SYMBOLS[currencyCode];
    return symbol ? (symbol + amount) : (amount + ' ' + currencyCode);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function footwearQuantity(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (CONFIG.footwearTypes.indexOf(item.product_type) !== -1) {
        total += item.quantity;
      }
    });
    return total;
  }

  function findInsigniaLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === CONFIG.insigniaVariantId) return cart.items[i];
    }
    return null;
  }

  function addInsignia(qty, engraving, finish) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: CONFIG.insigniaVariantId,
          quantity: qty,
          properties: {
            'Engraving': engraving || '(sent separately by email)',
            'Finish': finish
          }
        }]
      })
    });
  }

  function setInsigniaQuantity(qty, currentLine) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentLine.key, quantity: qty })
    });
  }

  function removeInsignia(currentLine) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentLine.key, quantity: 0 })
    });
  }

  function priceLine(qty, currencyCode) {
    if (pricePerPairCents == null) return '';
    var perPair = formatMoney(pricePerPairCents, currencyCode);
    var total = formatMoney(pricePerPairCents * qty, currencyCode);
    return perPair + ' per pair — ' + total + ' total.';
  }

  function render(container, cart) {
    var pairs = footwearQuantity(cart);
    var line = findInsigniaLine(cart);
    var eligible = pairs >= CONFIG.minPairs;

    if (!syncing && eligible && line && line.quantity < pairs) {
      syncing = true;
      setInsigniaQuantity(pairs, line).then(refreshAll).then(function () { syncing = false; });
      return;
    }
    if (!syncing && !eligible && line) {
      syncing = true;
      removeInsignia(line).then(refreshAll).then(function () { syncing = false; });
      return;
    }

    container.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'edev-insignia';

    if (!eligible) {
      var remaining = CONFIG.minPairs - pairs;
      var progressText = pairs > 0
        ? ('You currently have ' + pairs + ' of ' + CONFIG.minPairs + ' — ' + remaining + ' more to unlock customization.')
        : '';
      wrap.innerHTML =
        '<p class="edev-insignia__note">Engraved insignias become available once your order includes ' +
        CONFIG.minPairs + ' pairs of footwear or more — mixed styles and sizes all count toward the total. ' + progressText + '</p>';
    } else if (line) {
      var finishVal = (line.properties && line.properties['Finish']) || '';
      var engravingVal = (line.properties && line.properties['Engraving']) || '';
      var summary = document.createElement('div');
      summary.className = 'edev-insignia__summary';

      var priceEl, qtyInput;
      summary.innerHTML =
        '<p><strong>Engraved insignias added</strong><br>' +
        '“' + engravingVal + '” — ' + finishVal + ' finish.</p>' +
        '<label class="edev-insignia__label">Quantity (minimum ' + pairs + ' pairs)' +
        '<span class="edev-insignia__qty-row">' +
        '<input type="number" class="edev-insignia__input edev-insignia__qty-input" min="' + pairs + '" step="1" value="' + line.quantity + '">' +
        '<button type="button" class="edev-insignia__update">Update</button>' +
        '</span></label>' +
        '<p class="edev-insignia__price" data-price-display></p>' +
        '<button type="button" class="edev-insignia__remove">Remove</button>';

      qtyInput = summary.querySelector('.edev-insignia__qty-input');
      priceEl = summary.querySelector('[data-price-display]');

      function updatePriceDisplay() {
        var q = Math.max(pairs, parseInt(qtyInput.value, 10) || pairs);
        priceEl.textContent = priceLine(q, cart.currency);
      }
      updatePriceDisplay();
      qtyInput.addEventListener('input', updatePriceDisplay);

      summary.querySelector('.edev-insignia__update').addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var newQty = Math.max(pairs, parseInt(qtyInput.value, 10) || pairs);
        btn.disabled = true;
        syncing = true;
        setInsigniaQuantity(newQty, line).then(refreshAll).then(function () { syncing = false; });
      });

      summary.querySelector('.edev-insignia__remove').addEventListener('click', function (e) {
        e.currentTarget.disabled = true;
        syncing = true;
        removeInsignia(line).then(refreshAll).then(function () { syncing = false; });
      });

      wrap.appendChild(summary);
    } else {
      var form = document.createElement('form');
      form.className = 'edev-insignia__form';
      form.innerHTML =
        '<p class="edev-insignia__heading"><strong>Add engraved insignias</strong><br>' +
        'High-precision anodized alloy, laser-engraved to order — one pair per pair of footwear or more. ' +
        'You qualify for ' + pairs + ' pairs, and can add as many beyond that as you like.</p>' +
        '<p class="edev-insignia__artwork-note">Have a specific logo or vector instead of text? Email it to ' +
        '<a href="mailto:' + CONFIG.artworkEmail + '">' + CONFIG.artworkEmail + '</a> after checkout, referencing your order number.</p>' +
        '<label class="edev-insignia__label">Engraving text (yacht, crew, or personal name)' +
        '<input type="text" class="edev-insignia__input" name="engraving" maxlength="30" placeholder="Leave blank if sending artwork by email"></label>' +
        '<label class="edev-insignia__label">Finish' +
        '<select class="edev-insignia__select" name="finish">' +
        CONFIG.finishes.map(function (f) { return '<option value="' + f + '">' + f + '</option>'; }).join('') +
        '</select></label>' +
        '<label class="edev-insignia__label">Quantity (minimum ' + pairs + ' pairs)' +
        '<input type="number" class="edev-insignia__input" name="quantity" min="' + pairs + '" step="1" value="' + pairs + '"></label>' +
        '<p class="edev-insignia__price" data-price-display></p>' +
        '<button type="submit" class="edev-insignia__submit">Add insignias</button>';

      var qtyField = form.querySelector('[name="quantity"]');
      var priceEl2 = form.querySelector('[data-price-display]');
      function updatePrice2() {
        var q = Math.max(pairs, parseInt(qtyField.value, 10) || pairs);
        priceEl2.textContent = priceLine(q, cart.currency);
      }
      updatePrice2();
      qtyField.addEventListener('input', updatePrice2);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var engraving = form.querySelector('[name="engraving"]').value.trim();
        var finish = form.querySelector('[name="finish"]').value;
        var qty = Math.max(pairs, parseInt(qtyField.value, 10) || pairs);
        var btn = form.querySelector('.edev-insignia__submit');
        btn.disabled = true;
        btn.textContent = 'Adding…';
        syncing = true;
        addInsignia(qty, engraving, finish).then(refreshAll).then(function () { syncing = false; });
      });

      wrap.appendChild(form);
    }

    container.appendChild(wrap);
  }

  function renderAll(cart) {
    var containers = document.querySelectorAll('[data-edev-insignia-addon]');
    for (var i = 0; i < containers.length; i++) {
      render(containers[i], cart);
    }
  }

  function refreshAll() {
    return fetchCart().then(renderAll);
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (isCartMutation) {
        setTimeout(refreshAll, 150);
      }
      return response;
    });
  };

  loadPrice();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
